import cookie from "react-cookies";
import { env, environment } from "../common/sysco-ui-components/config/constant";
import Axios from "axios";
import { SUPPLIER_PATH } from "./path";

export const DP_ENV = environment();

export function prodLogin() {
  if (environment() === '-dev') {
    return '-np';
  } else return ""
}

export async function  getToken(){
  const res= await Axios({
    url: `${SUPPLIER_PATH}/get-otds-token`,
    method: "GET",
    headers: {
      "Access-Control-Allow-Origin": "*"
    }  })
    .then(response => {
      cookie.save("serviceToken", response.data.otdsToken, { path: "/" });
      return response.data.otdsToken
    })
    .catch(err => { 
      return null
    })
    return await res
}

export const OTCS_URL = `https://les${env()}.sysco.com/otcs/cs.exe`;
export const API_V2_NODES = "api/v2/nodes";
export const CONTENT = "content";
